export const version = '0.777.3'
export const chameleonWebVersion = '9.7.1'
export const chameleonCoreVersion = '7.8.0'
